<script>
export default {
  name: "block-title",
  props: {
    title: {
      type: String
    },
    blockStyle: {
      type: Object
    }
  }
}
</script>

<template>
  <div class="block-title border-bottom-dark" :style="blockStyle">
    <h3>{{title}}</h3>
    <slot />
  </div>
</template>